import type {
  IVirtualAutocompleteChildRowHeightParameters,
  IVirtualAutocompleteListBodyHeightParameters,
  VirtualAutocompleteRow,
} from '@features/autocompleteVirtualization/types';

export const sumVirtualAutocompleteRowHeights = (
  items: VirtualAutocompleteRow[],
  getChildRowHeight: (child: VirtualAutocompleteRow) => number
): number => {
  let total = 0;

  for (const element of items) {
    total += getChildRowHeight(element);
  }

  return total;
};

export const getVirtualAutocompleteChildRowHeight = (
  parameters: IVirtualAutocompleteChildRowHeightParameters
): number => {
  const { child, groupRowHeightPx, optionRowHeightPx } = parameters;

  if (Object.hasOwn(child, 'group')) {
    return groupRowHeightPx;
  }

  return optionRowHeightPx;
};

export const getVirtualAutocompleteListBodyHeightPx = (
  parameters: IVirtualAutocompleteListBodyHeightParameters
): number => {
  const {
    items,
    itemCount,
    groupRowHeightPx,
    optionRowHeightPx,
    maxVisibleOptionRows,
  } = parameters;

  const getChildRowHeight = (child: VirtualAutocompleteRow) =>
    getVirtualAutocompleteChildRowHeight({
      child,
      groupRowHeightPx,
      optionRowHeightPx,
    });

  if (itemCount > maxVisibleOptionRows) {
    return maxVisibleOptionRows * optionRowHeightPx;
  }

  return sumVirtualAutocompleteRowHeights(items, getChildRowHeight);
};
